/* eslint-disable react/jsx-props-no-spreading */

import React, { useContext, useMemo } from "react";
import "react-customize-token-input/dist/react-customize-token-input.css";
import { useParams } from "react-router-dom";
import APIVariableSelect from "../../../Components/APIVariableSelect/APIVariableSelect";
import Input from "../Inputs/Input";
import ConditionOptionsConfig from "./ConditionOptionsConfig";
import Context from "../../../../store/context";
import CommonInput from "../Inputs/CommonInput";
import Errors from "../../../Components/Errors";
import MyModal from "../../../../Common/MyModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import CompoundInput from "../Inputs/CompoundInput";
import JsonCollapse from "../../../Components/JsonCollapse";
import InputLabel from "../Inputs/InputLabel";

export default function Condition({ condition, setCondition, index, event }) {
  const context = useContext(Context);
  const { workflowUUID } = useParams();

  const pageProps = JSON.parse(
    document.querySelector("#app").dataset.page
  ).props;

  const logicConditions = ConditionOptionsConfig(
    condition,
    context,
    event,
    workflowUUID
  );

  const getConditonDefaults = (values) =>
    logicConditions[values[0]]?.inputs?.reduce(
      (p, c) => {
        if (
          c.type === "property" &&
          c.defaultValue !== undefined &&
          c.defaultValue !== null
        ) {
          return { ...p, [c.field]: c.defaultValue[0] };
        }
        if (
          c.type === "option" &&
          c.defaultValue !== undefined &&
          c.defaultValue !== null
        ) {
          return {
            ...p,
            Options: [
              ...p.Options,
              ...c.defaultValue.map((Value) => ({ Type: c.field, Value })),
            ],
          };
        }
        if (
          c.type === "compound" &&
          c.defaultValue !== undefined &&
          c.defaultValue !== null
        ) {
          return {
            ...p,
            Options: [
              ...p.Options,
              ...c.defaultValue.map((Value) =>
                typeof Value === "object"
                  ? {
                      Type: c.field,
                      ValueFrom: "static",
                      Key: c.props.keyValue,
                      ...Value,
                    }
                  : {
                      Type: c.field,
                      Value,
                      ValueFrom: "static",
                      Key: c.props.keyValue,
                    }
              ),
            ],
          };
        }
        return p;
      },
      { Options: [] }
    );

  const typeChangeHandler = (values) => {
    setCondition({
      UUID: condition.UUID,
      Logical: condition.Logical,
      Type: values[0],
      // set condition defaults
      // ...conditionDefaults({ context })[values[0]],
      ...getConditonDefaults(values),
      Options: [
        ...(values[0] !== "form-validation"
          ? [
              {
                Value: "True",
                Type: "BooleanOperator",
              },
            ]
          : []),
        // ...(conditionDefaults({ context })[values[0]]?.Options ?? []),
        ...(getConditonDefaults(values)?.Options ?? []),
      ],
    });
  };

  return (
    <div>
      <div className="d-flex flex-wrap gap-2">
        {index > 0 && (
          // LOGICAL AND/OR
          <div
            className={`conditions-select-logical bg-purple-gradient p-2 rounded-2`}
          >
            <Input
              isSummary={!setCondition}
              label="AND / OR"
              inputType="select"
              isValidNewOption={() => false}
              options={[
                { value: "AND", label: "AND" },
                { value: "OR", label: "OR" },
              ]}
              value={[condition.Logical || "AND"]}
              onChange={(options) =>
                setCondition({ ...condition, Logical: options[0] })
              }
            />
          </div>
        )}

        {/* CONDITION TYPE */}
        <div
          className={`conditions-select-type bg-purple-gradient p-2 rounded-2`}
        >
          <Input
            isSummary={!setCondition}
            label="Condition type"
            autoFocus={!condition.Type}
            inputType="select"
            isSearchable
            isValidNewOption={() => false}
            inputHelp="Select type of condition or type to search"
            options={Object.keys(logicConditions)
              // check if the condition is available in this event
              .filter(
                (cond) => logicConditions[cond].events?.includes(event) ?? true
              )
              .map((opt) => ({
                value: opt,
                label: logicConditions[opt].label,
              }))}
            value={[condition.Type || "Select Type"]}
            onChange={typeChangeHandler}
          />
        </div>

        {
          // API VARIABLE
          condition.Type === "Api Variables" && (
            <div className="api-variable me-1">
              <APIVariableSelect
                className="d-inline-block me-1"
                onChange={(option) =>
                  setCondition({ ...condition, apiVariable: option.value })
                }
                value={{
                  value: condition.apiVariable,
                  label: condition.apiVariable || "Select API Variable",
                }}
              />
            </div>
          )
        }

        {
          // inputs
          logicConditions[condition.Type]?.inputs?.map((input, i) => (
            <CommonInput
              isConditionInput
              className={`bg-purple-gradient p-2 rounded-2 ${
                input.className || ""
              }`}
              key={`${condition.UUID}-${input.field}-${i}${input.props?.key}`}
              {...{ input, condition, setCondition }}
            />
          ))
        }

        {condition.Type && condition.Type !== "form-validation" && (
          <CommonInput
            className={`bg-purple-gradient p-2 rounded-2 `}
            condition={condition}
            setCondition={setCondition}
            input={{
              type: "option",
              field: "BooleanOperator",
              props: {
                label: "Is True/False",
                inputType: "select",
                isValidNewOption: () => false,
                options: [
                  { value: "True", label: "is true" },
                  { value: "False", label: "is false" },
                ],
              },
            }}
          />
        )}

        {([
          "EmailOrSmsBody",
          "EmailSubject",
          "reply:message",
          "variable:text",
          "validate:phone-number",
          "component:package",
          "workflow:contacts-count",
        ].includes(condition.Type) ||
          // contact:in with where group or groupVariable
          (["contact:in"].includes(condition.Type) &&
            condition.Options?.find(
              (o) =>
                o.Type === "where" &&
                ["group-variable", "group"].includes(o.Value)
            ))) &&
          setCondition && (
            <div className="bg-purple-gradient p-2 rounded-2">
              <div>
                <InputLabel>Output</InputLabel>
              </div>
              <div className="p-2 text-center">
                <MyModal
                  label={<FontAwesomeIcon icon={faCog} />}
                  as="offcanvas"
                  heading="Save output to variable"
                  size="xl"
                >
                  <div>
                    <CompoundInput
                      label="Output Variable"
                      isClearable
                      isInputArgumentOnly
                      inputArgumentProps={
                        ["validate:phone-number"].includes(condition.Type)
                          ? { Format: ["voice", "sms", "contact"] }
                          : ["contact:in"].includes(condition.Type) &&
                            condition.Options?.find(
                              (o) =>
                                o.Type === "where" &&
                                ["group-variable", "group"].includes(o.Value)
                            )
                          ? { Format: ["group"] }
                          : { Format: "short-text" }
                      }
                      showOperationSelector
                      isValidNewOption={(v) => v.trim().length > 0}
                      values={[
                        {
                          ValueFrom: "inputArgument",
                          Value: condition.OutputVariableUuid,
                          MainThread: condition.OutputVariableUseMainThread,
                          Operation: condition.OutputVariableOperation,
                        },
                      ]}
                      onChange={(values) =>
                        setCondition({
                          ...condition,
                          OutputVariableUuid: values[0].Value,
                          OutputVariableUseMainThread: values[0].MainThread,
                          OutputVariableOperation: values[0].Operation,
                        })
                      }
                      condition={condition}
                    />
                  </div>
                  <JsonCollapse json={condition} />
                </MyModal>
              </div>
            </div>
          )}
      </div>
      <div className="text-danger">
        <Errors
          filterFn={(err) => err.condition?.UUID === condition.UUID}
          linkDisabled
        />
      </div>
    </div>
  );
}
